import React from 'react';
import { Box, costFormater, Text } from '@common-fe/common-fe';

import { useGetDecimal } from '../hooks';

import { AmountDecimal, AmountValue } from './EmployerAmount.styles';

interface Props {
  value: number;
}
const EmployerClaimSpendTitle: React.FC<Props> = ({ value }) => {
  const { value: cuttedValue, decimal } = useGetDecimal(value);
  // Font size is driven by the length of the formatted whole-dollar string
  // (number-based breakpoints), not the viewport or container width.
  const formatted = costFormater(cuttedValue);

  return (
    <div>
      <Box width={{ min: '190px' }}>
        <Text weight={700}>
          <AmountValue $formatted={formatted}>
            {formatted}
            <AmountDecimal $formatted={formatted}>{decimal || '00'}</AmountDecimal>
          </AmountValue>
        </Text>
      </Box>
    </div>
  );
};

export default EmployerClaimSpendTitle;
